import React, { useLayoutEffect, useState } from 'react';
import { debounce } from '~/util';
import { ThemeContext } from './ThemeContext';
import {
    applyThemeVars,
    computeThemeVars,
    defaultColor,
    setPrimaryColorCookie,
} from './theme';

export const ThemeProvider: React.FC<{
    children: React.ReactNode;
    initialColor?: string;
}> = ({ children, initialColor }) => {
    const [primaryColor, setPrimaryColorState] = useState<string>(
        initialColor ?? defaultColor,
    );

    useLayoutEffect(() => {
        applyThemeVars(
            document.documentElement,
            computeThemeVars(primaryColor),
        );
    }, [primaryColor]);

    const [setPrimaryColorCookieDebounced] = useState(() =>
        debounce((color: string) => {
            setPrimaryColorCookie({ data: { color } }).catch(() => {});
        }, 1000),
    );

    const setPrimaryColor = (color: string) => {
        setPrimaryColorState(color);
        setPrimaryColorCookieDebounced(color);
    };
    const resetPrimaryColor = () => setPrimaryColor(defaultColor);

    const isDefaultColor = primaryColor === defaultColor;

    return (
        <ThemeContext.Provider
            value={{
                primaryColor,
                setPrimaryColor,
                resetPrimaryColor,
                isDefaultColor,
            }}
        >
            {children}
        </ThemeContext.Provider>
    );
};
